import { Tooltip } from '@flowus/common/components/tooltip';
import { useOpenModal } from '@flowus/common/next-modal';
import type { FC } from 'react';
import { Icon } from 'src/common/components/icon';
import { currentVersion, publicLink } from 'src/common/const';
import { PRODUCT_ALL_NAME } from 'src/const/title';
import { Images } from 'src/image';

export const Footer: FC = () => {
  const openModal = useOpenModal();
  const openQr = (e: React.MouseEvent) => {
    openModal.dropdown({
      placement: 'top-end',
      popcorn: e.currentTarget,
      content: () => (
        <div className="next-modal">
          <img src={Images.qr} className="w-48" alt="" />
        </div>
      ),
    });
  };

  return (
    <div className="border-t flex items-center justify-between py-1.5 px-4 bg-white2">
      <div className="pointer-events-none text-grey4 text-t4">
        {`${PRODUCT_ALL_NAME} ${currentVersion}`}
      </div>
      <div className="flex items-center text-grey3 space-x-4">
        <Tooltip popup="官网">
          <Icon
            onClick={() => {
              window.open(publicLink.product);
            }}
            name={'IcHome'}
            className="animate-click"
            size="middle"
          />
        </Tooltip>
        {!__BUILD_IN__ && (
          <Tooltip popup="微信公众号">
            <Icon onClick={openQr} name={'IcWechatXibao'} className="animate-click" size="middle" />
          </Tooltip>
        )}
        {!__BUILD_IN__ && (
          <Tooltip popup="下载客户端">
            <Icon
              onClick={() => {
                window.open(publicLink.appDownload);
              }}
              name={'IcMacosWindows'}
              className="animate-click"
              size="middle"
            />
          </Tooltip>
        )}
      </div>
    </div>
  );
};
